import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const STUDENT = 'student'
const STATUS = 'status'
const SESSION = 'session'
const ABSENCE_MINUTES = 'absence_minutes'
const PARTICIPATION_POINTS = 'participation_points'
const COMMENT = 'comment'

/**
 * Form model
 */
const formModel = () => {
  return {
    [STUDENT]: {
      label: `${t('common.student')}`,
      name: STUDENT,
      required: true,
    },
    [STATUS]: {
      label: `${t('common.status')}`,
      name: STATUS,
      required: true,
    },
    [SESSION]: {
      label: `${t('common.session')}`,
      name: SESSION,
      required: true,
    },
    [ABSENCE_MINUTES]: {
      label: `${t('attendance.absence-minutes')}`,
      name: ABSENCE_MINUTES,
    },
    [PARTICIPATION_POINTS]: {
      label: `${t('attendance.participation-points')}`,
      name: PARTICIPATION_POINTS,
    },
    [COMMENT]: {
      label: `${t('common.comment')}`,
      name: COMMENT,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [STUDENT]: null,
  [STATUS]: '',
  [SESSION]: null,
  [ABSENCE_MINUTES]: '',
  [PARTICIPATION_POINTS]:'',
  [COMMENT]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [STUDENT]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .required(`${t('errors.required-error-message')}`)
      .nullable(),
    [STATUS]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .required(`${t('errors.required-error-message')}`)
      .nullable(),
    [SESSION]: yup
      .object()
      .shape({
        title: yup
          .string()
          .nullable()
          .required(`${t('errors.required-error-message')}`),
      })
      .required(`${t('errors.required-error-message')}`)
      .nullable(),
    [ABSENCE_MINUTES]: yup.number(),
    [PARTICIPATION_POINTS]: yup.number(),
    [COMMENT]: yup.string(),
  })

export default formModel
